type RequestParams = Record<string, unknown> | undefined;

const investorScopedPaths = ['/holdings', '/transactions', '/messages'];

export function withInvestorScopeParams(
  url: string | undefined,
  method: string | undefined,
  params: RequestParams,
  selectedInvestorId: number | null
) {
  if (
    !selectedInvestorId ||
    method?.toLowerCase() !== 'get' ||
    !investorScopedPaths.some((path) => url?.startsWith(path))
  ) {
    return params;
  }

  if (params && Object.prototype.hasOwnProperty.call(params, 'investorId')) {
    return params;
  }

  return {
    ...(params || {}),
    investorId: selectedInvestorId,
  };
}
